import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Allows access for:
 *  - Consumer + AuctionAccess
 *  - Admin
 *  - SuperAdmin
 */
export const auctionAccessGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getCurrentUser();

  if (!user) {
    router.navigate(['/login']);
    return false;
  }

  const isAdminOrSuper = authService.hasAnyRole('Admin', 'SuperAdmin');
  const isConsumerWithAccess =
    authService.hasRole('Consumer') && authService.hasRole('AuctionAccess');

  if (!isAdminOrSuper && !isConsumerWithAccess) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
